export var AdLabelAppearance;
(function (AdLabelAppearance) {
    AdLabelAppearance["primary"] = "primary";
    AdLabelAppearance["neutralDark"] = "neutralDark";
    AdLabelAppearance["neutralLight"] = "neutralLight";
})(AdLabelAppearance || (AdLabelAppearance = {}));
